export default __webpack_public_path__ + "static/media/empty_favorites_auth_users.08efac0b.svg";